export const changeHistory = {
  SearchCampaignChangeHistoryReport: {
    mandatory: [
      'DateTime',
    ],
    default: [
      'DateTime',
      'CampaignName',
      'AdGroupName',
      'ChangedBy',
      'EntityName',
      'AttributeChanged',
      'ItemChanged',
      'HowChanged',
      'OldValue',
      'NewValue',
    ],
  },
  UserRoleChangeHistoryReport: {
    default: [
      'CustomerName',
      'AccountName',
      'ChangeMadeBy',
      'ChangeMadeTo',
      'AttributeChanged',
      'HowChanged',
      'OldValue',
      'NewValue',
      'DateTime',
    ],
    mandatory: [
      'DateTime',
    ],
  },
  FraudChangeHistoryReport: {
    mandatory: [
      'UserId',
      'AccountId',
      'AccountName',
      'CustomerId',
      'CustomerName',
      'ChangeTotalCount',
    ],
    default: [
      'UserId',
      'AccountId',
      'AccountName',
      'CustomerId',
      'CustomerName',
      'ChangeTotalCount',
    ],
  },
};

